import * as React from "react";

interface DrawerGiftcardHelpConsumerInterface {
  drawerShouldBePresenting: boolean;
}
const defaultValue = {} as unknown as DrawerGiftcardHelpConsumerInterface;
const DrawerGiftcardHelpContext = React.createContext(defaultValue);

interface DrawerGiftcardHelp_ControllerInterface {
  handleOpen: () => void;
  handleClose: () => void;
}
const controllerDefaultValue =
  {} as unknown as DrawerGiftcardHelp_ControllerInterface;
const DrawerGiftcardHelp_ControllerContext = React.createContext(
  controllerDefaultValue
);

export const DrawerGiftcardHelpProvider: React.FunctionComponent = (props) => {
  const [drawerShouldBePresenting, setDrawerShouldBePresenting] =
    React.useState(false);

  const handleOpen: DrawerGiftcardHelp_ControllerInterface["handleOpen"] =
    React.useCallback(() => {
      setDrawerShouldBePresenting(true);
    }, []);

  const handleClose: DrawerGiftcardHelp_ControllerInterface["handleClose"] =
    React.useCallback(() => {
      setDrawerShouldBePresenting(false);
    }, []);

  const value: DrawerGiftcardHelpConsumerInterface = React.useMemo(
    () => ({
      drawerShouldBePresenting,
    }),
    [drawerShouldBePresenting]
  );
  const controllerValue: DrawerGiftcardHelp_ControllerInterface = React.useMemo(
    () => ({
      handleOpen,
      handleClose,
    }),
    [handleOpen, handleClose]
  );
  return (
    <DrawerGiftcardHelpContext.Provider value={value}>
      <DrawerGiftcardHelp_ControllerContext.Provider value={controllerValue}>
        {props.children || []}
      </DrawerGiftcardHelp_ControllerContext.Provider>
    </DrawerGiftcardHelpContext.Provider>
  );
};

export const useDrawerGiftcardHelp = () => {
  const value = React.useContext(DrawerGiftcardHelpContext);
  if (value === defaultValue) {
    throw new Error(
      "useDrawerGiftcardHelp must be used within a DrawerGiftcardHelpProvider"
    );
  }
  return value;
};

export const useDrawerGiftcardHelp_asController = () => {
  const value = React.useContext(DrawerGiftcardHelp_ControllerContext);
  if (value === controllerDefaultValue) {
    throw new Error(
      "useDrawerGiftcardHelp_asController must be used within a DrawerGiftcardHelpProvider"
    );
  }
  return value;
};
